import { getExchangePrice } from '@/features/purchase/purchaseActions';
import {
  exchangePriceSelector,
  selectedInboundOfferMapSelector,
  selectedOutboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { useDispatch, useSelector } from '@/store/utils';
import { isNonEmptyString } from '@/utils/typeGuards';
import { useEffect, useMemo } from 'react';

export const useChangeExchangePrice = () => {
  const dispatch = useDispatch();
  const { hasSelection } = useChangeBookingSelection();
  const outboundOfferMap = useSelector(selectedOutboundOfferMapSelector);
  const inboundOfferMap = useSelector(selectedInboundOfferMapSelector);
  const exchangePrice = useSelector(exchangePriceSelector);

  const offerIds = useMemo(
    () =>
      [
        ...Object.values(outboundOfferMap).map(({ id }) => id),
        ...Object.values(inboundOfferMap).map(({ id }) => id),
      ].filter(isNonEmptyString),
    [outboundOfferMap, inboundOfferMap]
  );

  // Stable key so the effect only re-fires when the actual set of selected
  // offer IDs changes, not on every render that produces a new array.
  const offerIdsKey = useMemo(
    () => offerIds.slice().sort().join('|'),
    [offerIds]
  );

  useEffect(() => {
    if (!hasSelection || offerIds.length === 0) return;
    dispatch(getExchangePrice(offerIds));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSelection, offerIdsKey, dispatch]);

  return { exchangePrice };
};
